export const CATEGORY_ORDER = [
  "7a",
  "6a",
  "5a",
  "4a",
  "3a",
  "2a",
  "open",
] as const;

export function normalizeCategoryValue(value: unknown): string {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  return CATEGORY_ORDER.includes(raw as (typeof CATEGORY_ORDER)[number])
    ? raw
    : "";
}

export function normalizeSexValue(value: unknown): "male" | "female" | "" {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (raw === "male" || raw === "m" || raw === "masculino") return "male";
  if (raw === "female" || raw === "f" || raw === "feminino") return "female";
  return "";
}

export function resolveChallengeGender(
  value: unknown,
): "male" | "female" | "mixed" | "open" | "" {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (raw === "male" || raw === "female" || raw === "mixed" || raw === "open")
    return raw;
  return "";
}

export function resolveChallengeCategoryForUser({
  challengeGender,
  challengeCategory,
  challengeCategoryMale,
  challengeCategoryFemale,
  userSex,
}: {
  challengeGender: "male" | "female" | "mixed" | "open" | "";
  challengeCategory: string;
  challengeCategoryMale: string;
  challengeCategoryFemale: string;
  userSex: "male" | "female" | "";
}) {
  if (challengeGender === "male")
    return challengeCategoryMale || challengeCategory || "";
  if (challengeGender === "female")
    return challengeCategoryFemale || challengeCategory || "";
  if (challengeGender === "mixed" || challengeGender === "open") {
    if (userSex === "female") {
      return (
        challengeCategoryFemale ||
        challengeCategoryMale ||
        challengeCategory ||
        ""
      );
    }
    if (userSex === "male") {
      return (
        challengeCategoryMale ||
        challengeCategoryFemale ||
        challengeCategory ||
        ""
      );
    }
    return (
      challengeCategory ||
      challengeCategoryMale ||
      challengeCategoryFemale ||
      ""
    );
  }
  if (challengeCategory) return challengeCategory;
  if (userSex === "female")
    return challengeCategoryFemale || challengeCategoryMale || "";
  if (userSex === "male")
    return challengeCategoryMale || challengeCategoryFemale || "";
  return challengeCategoryMale || challengeCategoryFemale || "";
}

export function isUserEligibleForChallengeRule({
  userSex,
  userCategory,
  challengeGender,
  challengeCategory,
}: {
  userSex: "male" | "female" | "";
  userCategory: string;
  challengeGender: "male" | "female" | "mixed" | "open" | "";
  challengeCategory: string;
}) {
  if (challengeGender && challengeGender !== "open") {
    if (userSex !== "male" && userSex !== "female") return false;
    if (challengeGender !== "mixed" && challengeGender !== userSex)
      return false;
  }
  if (!challengeCategory) return true;
  if (!userCategory) return false;
  const userIndex = CATEGORY_ORDER.indexOf(
    userCategory as (typeof CATEGORY_ORDER)[number],
  );
  const challengeIndex = CATEGORY_ORDER.indexOf(
    challengeCategory as (typeof CATEGORY_ORDER)[number],
  );
  if (userIndex < 0 || challengeIndex < 0) return false;
  const categoryDistance = challengeIndex - userIndex;
  return categoryDistance === 0 || categoryDistance === 1;
}
